import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { STORAGE_KEYS } from '../../utils/constants/storage-keys';
import { sessionStorageHelper } from '../../utils/storage-helpers/session-storage-helper';

// Define a type for the slice state
interface SystemState {
	checkoutDrawerVisible: boolean;
	productsRefinements?: any;
	salesAgent: number;
	isAdmin: boolean;
	salesGroup: string | undefined;
}

// Define the initial state using that type
const initialState: SystemState = {
	checkoutDrawerVisible: false,
	productsRefinements: undefined,
	salesAgent: -1,
	isAdmin: false,
	salesGroup: undefined,
};

export const systemSlice = createSlice({
	name: 'system',
	// `createSlice` will infer the state type from the `initialState` argument
	initialState,
	reducers: {
		initSalesAgent: (state, action: PayloadAction<number>) => {
			state.salesAgent = action.payload;

			sessionStorageHelper.setStorageItem(
				STORAGE_KEYS.BV_SYSTEM_SALES_AGENT,
				action.payload,
			);
		},
		initIsAdmin: (state, action: PayloadAction<boolean>) => {
			state.isAdmin = action.payload;
			sessionStorageHelper.setStorageItem(
				STORAGE_KEYS.BV_SYSTEM_IS_ADMIN,
				action.payload,
			);
		},
		initSalesGroup: (state, action: PayloadAction<string | undefined>) => {
			state.salesGroup = action.payload;
			sessionStorageHelper.setStorageItem(
				STORAGE_KEYS.BV_SYSTEM_SALES_GROUP,
				action.payload,
			);
		},
		keepProductsRefinements: (state, action: PayloadAction<any>) => {
			state.productsRefinements = action.payload;
		},
		toggleCheckoutDrawer: (state, action: PayloadAction<boolean>) => {
			state.checkoutDrawerVisible = action.payload;
		},
	},
});

export const {
	initSalesAgent,
	keepProductsRefinements,
	toggleCheckoutDrawer,
	initIsAdmin,
	initSalesGroup,
} = systemSlice.actions;

export default systemSlice.reducer;
